import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { holidayAdd, holidayDetail as _holidayDetail, holidayEdit } from 'api/Attendance';

/**
 * @param { String } str 2021/11/15
 * @returns { Date }
 */
var createDate = function createDate(str) {
  // return str.replaceAll('-', '/')
  return new Date(str.replaceAll('-', '/'));
};

// 假期规则参数
var listItem = function listItem(year) {
  return {
    can_edit: true,
    year: year,
    date: '',
    holiday_name_th: '',
    holiday_name_en: '',
    holiday_name_zh: ''
  };
};
var form = function form() {
  return {
    // 规则名称
    name: '',
    // 年份
    year: '',
    // table list
    date_list: []
  };
};
export default {
  props: {
    // 编辑或新建
    isEdit: {
      type: Boolean
    },
    // 是否仅查看
    isView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title: function title() {
      if (this.isView) return this.form.name;
      return this.isEdit ? '1845' : '1822';
    }
  },
  watch: {
    visible: function visible() {
      !this.isEdit && (this.form.year = String(new Date().getFullYear()));
    }
  },
  data: function data() {
    var _this = this;
    return {
      rules: {
        name: [{
          required: true,
          message: this.$t('850')
        }],
        year: [{
          required: true,
          message: this.$t('839')
        }]
      },
      // save loading
      loading: false,
      // 弹窗展示
      visible: false,
      // 年份限制必须是当年及以后
      pickerOptionsYear: {
        disabledDate: function disabledDate(time) {
          return time <= new Date();
        }
      },
      // 时间限制
      pickerOptionsTime: {
        disabledDate: function disabledDate(time) {
          var year = _this.form.year;
          // 组件循环日期
          var cTime = time.getTime();
          // 当天的前一天
          var cuTime = new Date() - 86400000;
          // 获取已选年份的最后一天
          var nextYear = new Date(String(Number(year) + 1)) - 86400000;
          // 判断不能是以选日期
          var state = _this.form.date_list.some(function (element) {
            if (!element.date) return false;
            return createDate(element.date) - time === 0;
          });
          // 必须是已选年份且必须大于当天
          return state || cTime < cuTime || time < new Date(year) - 86400000 || cTime > nextYear;
        }
      },
      form: form(),
      // 编辑条目对应iD
      editId: '',
      // 编辑时查找所选年份是否有数据 并赋值给表格
      dateListMap: {},
      state: 0 // 0是新建 1是编辑
    };
  },

  methods: {
    // 获取详情
    holidayDetail: function holidayDetail(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var year, _yield$_holidayDetail, data, name, date_list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.editId = id;
              year = String(new Date().getFullYear()); // 默认当前年
              _this2.form.year = year;
              _context.next = 5;
              return _holidayDetail({
                id: id
              });
            case 5:
              _yield$_holidayDetail = _context.sent;
              data = _yield$_holidayDetail.data;
              if (data) {
                name = data.name, date_list = data.date_list;
                _this2.form.name = name;
                _this2.dateListMap = date_list;
                _this2.handleRemove(year);
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 年份变换 逻辑上没有年份则不能保存
    handleRemove: function handleRemove(v) {
      this.form.date_list = this.isEdit ? this.dateListMap[v] || [listItem(v)] : [listItem(v)];
    },
    // 删除当前行
    handleDel: function handleDel(index) {
      this.form.date_list.splice(index, 1);
    },
    // 添加行
    doAdd: function doAdd() {
      var _this$form = this.form,
        year = _this$form.year,
        date_list = _this$form.date_list;
      if (!year) return this.$message.warning(this.$t('1840'));
      date_list.push(listItem(year));
    },
    // 弹窗关闭前清空数据
    handlerClose: function handlerClose(deno) {
      this.$refs.form.resetFields();
      this.form = form();
      if (deno) deno();
    },
    // 取消
    handlerCancel: function handlerCancel() {
      this.visible = false;
      this.handlerClose();
    },
    // 提交
    doSubmit: function doSubmit() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var request = _this3.isEdit ? holidayEdit : holidayAdd;
          // 存储按钮loading
          _this3.loading = true;
          request(_objectSpread(_objectSpread({}, _this3.form), {}, {
            id: _this3.editId
          })).then(function () {
            // 关闭弹窗 表单还原
            _this3.visible = false;
            // 列表刷新
            _this3.$emit('updateTable');
            _this3.handlerClose();
          }).finally(function () {
            return _this3.loading = false;
          });
        }
      });
    }
  }
};